<template>
<footer class="c-footer print-hidden">
  <div class="c-footer__main">
    <div class="c-footer__left">
          <p>Pour proposer une partenariat dans le cadre du DigiScore, n’hésitez-pas à prendre contact avec l’AdN.</p>
      <p>© 2023 - DigiScore by Digital Wallonia {{ version }} - <router-link :to='{ name: "LegalInformation" }'>{{ $t('footer.privacyPolicy.text') }}</router-link></p>
      <div class="c-footer-nav__menu">
         <div class="c-footer-nav__menu-content">
          <p><strong>Contacter l'AdN</strong></p>
          <p>Avenue Prince de Liège, 133 <br />5100 Jambes</p>
          <p>tel <a href="tel:+32 (0)81 77 80 80">+32 (0)81 77 80 80</a></p>
          <a href="mailto:support@digitalwallonia.be">Contactez le support par mail</a>
         </div>
      </div>
    </div>
    <div class="c-footer__right">
      <div class="c-footer-logos__main">
        <a href="https://www.adn.be" target="_blank"><img src="@/assets/images/logos/logo-AdN-blanc.png" /></a>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      version: process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : '',
    };
  },
};
</script>
